var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "loupe",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.607,
    height: 12.606,
    viewBox: "0 0 12.607 12.606",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9464",
    "data-name": "Group 9464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7021",
    "data-name": "Path 7021",
    d: "M12.452,11.713,8.868,8.128a5,5,0,1,0-.743.743l3.585,3.585a.525.525,0,1,0,.743-.743ZM4.99,8.932A3.939,3.939,0,1,1,8.93,4.993,3.944,3.944,0,0,1,4.99,8.932Z",
    transform: "translate(0 -0.003)",
    fill: "#b0b0b3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.954bd059e8bd3d136f696fc1ef8ec6ce.svg";
export { ForwardRef as ReactComponent };